<div class="flex fx-row justify-content-between padding-bottom-1">
  <div class="flex fx-row">
    <uni-user-avatar
      *ngIf="project.owners.length > 0"
      [user]="project.owners[0].user"
      size="micro"></uni-user-avatar>
    <a
      [href]="getProfileUrl(project.owners[0]?.user)"
      target="_blank"
      class="no-decor margin-y-auto height-min padding-x-1 font-xs font-bolder">
      {{ fullNameTruncated | titlecase }}
    </a>
    <ng-container *ngIf="project.owners.length > 1">
      <div
        class="font-xxs sparro-grey-900 sparro-bg-grey-300 rounded-border padding-x-1 margin-y-auto height-min">
        +{{ project.owners.length - 1 }} others
      </div>
    </ng-container>
  </div>
  <div class="flex fx-row-reverse">
    <div
      fxLayout="row"
      fxLayoutAlign="flex-end center"
      *ngIf="self || project?.content?.published">
      <!-- <button
        mat-icon-button
        (click)="toggleBookmark()"
        matTooltipPosition="above"
        *ngIf="!self && project?.content?.published"
        matTooltip="{{ project.bookmark ? 'Remove from collection' : 'Add to collection' }}">
        <uni-image
          [src]="project?.bookmark ? icons.bookmark_fill : icons.bookmark"
          [height]="24"
          [width]="24"
          alt="Bookmark"
          classes="fit-cover margin-top-2">
        </uni-image>
      </button> -->
      <i class="{{ project.bookmark ? 'icon-add-to-collection-fill sparro-orange-600 cursor-pointer' : 'icon-add-to-collection cursor-pointer' }}" (click)="toggleBookmark()" 
        matTooltipPosition="above" *ngIf="project?.content?.published"
        matTooltip="{{ project.bookmark ? 'Remove from collection' : 'Add to collection' }}" matTooltipPosition="above">
      </i>
      <uni-context-menu
        [selfCheck]="self"
        [showContextMenuCheck]="showContextMenu"
        [projectCheck]="project"></uni-context-menu>
    </div>
  </div>
</div>
